import * as TYPE from "../types";
const initialState = {
  data: null,
  err: false,
  msg: null,
};
export const usersReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.REQUEST_USER_LIST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        msg: "Users found",
      };

    default:
      return state;
  }
};
